import styled from 'styled-components';
import { IonCard } from '@ionic/react';

export const IonCardWrapper = styled(IonCard)`
  max-width: 100%;
`;
